import { render, staticRenderFns } from "./InputStepView.vue?vue&type=template&id=04706922&scoped=true"
import script from "./InputStepView.vue?vue&type=script&lang=js"
export * from "./InputStepView.vue?vue&type=script&lang=js"
import style0 from "./InputStepView.vue?vue&type=style&index=0&id=04706922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04706922",
  null
  
)

export default component.exports